import { StrictMode } from 'react';
import { App } from './App';
import { ErrorBoundary } from './sentry';
import { SCREEN_SHELL } from './ui/kit';

/** Последний рубеж, и у него обязана быть кнопка.
 *
 *  Прежний текст звал обновить страницу, а обновлять было нечем: в
 *  установленном на устройство приложении браузерной кнопки перезагрузки
 *  нет вовсе, и ребёнок оставался в тупике с одной фразой на экране. Ниже —
 *  настоящий выход, и он же чинит самый частый случай: испорченное
 *  состояние в памяти уходит вместе с перезагрузкой. */
export function ПоследнийРубеж() {
  return (
    <main className={SCREEN_SHELL}>
      <h1 className="m-0 text-2xl font-semibold">Что-то сломалось</h1>
      <p className="m-0 text-[0.95rem] text-muted">
        Мы уже знаем об этой ошибке. Занятия сохранены — начни заново.
      </p>
      <button
        type="button"
        onClick={() => window.location.assign('/')}
        className="mt-auto rounded-[0.85rem] bg-accent p-4 text-[1.1rem] font-semibold text-white"
      >
        Начать заново
      </button>
    </main>
  );
}

/** Всё дерево приложения — ОТДЕЛЬНО от точки входа, и это не опрятность.
 *
 *  Пока оно жило в `main.tsx`, обещание последнего рубежа держала одна
 *  строка: `main.tsx` обязан СОДЕРЖАТЬ слово `ErrorBoundary`. Подсадка
 *  второй формы прошла зелёной — оставить ввоз и слово в комментарии, а
 *  `<App />` отрисовать голым: границы ошибок нет, слово на месте.
 *
 *  `main.tsx` теперь только проводка: побочные действия и `createRoot`.
 *  Импортировать его в прогоне нельзя (он тут же лезет в `document` и
 *  заводит Sentry), а вот это дерево — можно и нужно: оно ИСПОЛНЯЕТСЯ
 *  прогоном вместе с настоящей границей ошибок. */
export function Root() {
  return (
    <StrictMode>
      <ErrorBoundary fallback={<ПоследнийРубеж />}>
        <App />
      </ErrorBoundary>
    </StrictMode>
  );
}
